<script setup>
import { ref } from "vue";
import { useRouter } from "vue-router";
import AppDataTable from "@/components/AppDataTable.vue";
import ConfirmDialog from "@/components/ConfirmDialog.vue";
import { useResourceList } from "@/composables/useResourceList";
import { fetchPopups, deletePopup } from "./api";

const router = useRouter();
const columns = [
  { key: "title",   label: "Title",   sortable: true },
  { key: "type",    label: "Type" },
  { key: "actions", label: "Actions", align: "end", width: "220px" },
];
const { rows, loading, error, pendingDelete, deleting, load, askDelete, confirmDelete } =
  useResourceList({
    fetch: fetchPopups,
    remove: (id, row) => deletePopup(id, row?.imgUrl),
    mapRow: (p) => ({ id: p._id, title: p.title, type: p.type, imgUrl: p.imgUrl }),
  });

const previewDialog = ref(false);
const previewRow = ref(null);
function openPreview(row) {
  previewRow.value = row;
  previewDialog.value = true;
}
</script>

<template>
  <section>
    <div class="d-flex align-center justify-space-between mb-4 gap-3 flex-wrap">
      <h1 class="text-h5">Manage Popups</h1>
      <div class="d-flex gap-2">
        <VBtn variant="tonal" @click="load">Refresh</VBtn>
        <VBtn @click="router.push({ name: 'popups-new' })">Add Popup</VBtn>
      </div>
    </div>
    <VAlert v-if="error" type="error" closable class="mb-4" @click:close="error = ''">{{ error }}</VAlert>
    <AppDataTable :columns="columns" :rows="rows" :loading="loading" row-key="id" searchable search-placeholder="Search popups…" empty-text="No popups yet.">
      <template #cell-actions="{ row }">
        <VBtn size="small" variant="text" @click.stop="openPreview(row)">Preview</VBtn>
        <VBtn size="small" variant="text" @click.stop="router.push({ name: 'popups-edit', params: { id: row.id } })">Edit</VBtn>
        <VBtn size="small" color="error" variant="text" @click.stop="askDelete(row)">Delete</VBtn>
      </template>
    </AppDataTable>
    <ConfirmDialog :model-value="pendingDelete !== null" title="Delete popup?" :message="`Delete &quot;${pendingDelete?.title || 'this popup'}&quot;?`" :loading="deleting" @update:model-value="pendingDelete = null" @confirm="confirmDelete" />

    <VDialog v-model="previewDialog" max-width="360">
      <VCard>
        <VCardTitle class="pt-4 px-4">{{ previewRow?.title ?? 'Popup Preview' }}</VCardTitle>
        <VCardText class="pa-2">
          <VImg v-if="previewRow?.imgUrl" :src="previewRow.imgUrl" class="rounded" />
          <div v-else class="text-disabled text-center pa-4">No image available.</div>
        </VCardText>
        <VCardActions class="px-4 pb-4 justify-end">
          <VBtn @click="previewDialog = false">Close</VBtn>
        </VCardActions>
      </VCard>
    </VDialog>
  </section>
</template>
